<template>
  <div v-if="pages > 1">
    <AButton v-if="showPrevious" @click="$emit('go', page - 1)">&laquo;</AButton>
    <template v-if="complex">
      <template v-if="before > 3">
        <AButton @click="$emit('go', 0)">1</AButton>
        ...
        <AButton v-for="n in 2" :key="n" @click="$emit('go', page - (2 - n) - 1)">
          {{ page - (2 - n) }}
        </AButton>
      </template>
      <template v-else>
        <AButton v-for="n in before" :key="n" @click="$emit('go', n - 1)">
          {{ n }}
        </AButton>
      </template>

      <AButton class="bg-brand text-white cursor-default hover:outline-none">{{ page + 1 }}</AButton>

      <template v-if="after > 3">
        <AButton v-for="n in 2" :key="n" @click="$emit('go', page + n)">
          {{ page + n + 1 }}
        </AButton>
        ...
        <AButton @click="$emit('go', pages - 1)">{{ pages }}</AButton>
      </template>
      <template v-else>
        <AButton v-for="n in after" :key="n" @click="$emit('go', page + n)">
          {{ page + n + 1 }}
        </AButton>
      </template>
    </template>
    <AButton
      v-else
      v-for="n in pages"
      :key="n"
      :class="{ 'bg-brand text-white': n == page + 1 }"
      @click="$emit('go', n - 1)"
      >{{ n }}</AButton
    >
    <AButton v-if="showNext" @click="$emit('go', page + 1)">&raquo;</AButton>
  </div>
</template>

<script>
import AButton from './AButton.vue'
import { useSearchStore } from '@/stores/search'

export default {
  components: { AButton },
  props: {
    totalSize: Number,
  },
  data() {
    return {
      store: useSearchStore(),
    }
  },
  computed: {
    page() {
      return parseInt(this.store.page)
    },
    pageSize() {
      return parseInt(this.store.pageSize)
    },
    pages() {
      return Math.ceil(this.totalSize / this.pageSize)
    },
    showNext() {
      return this.page < this.pages - 1
    },
    showPrevious() {
      return this.page > 0
    },
    complex() {
      return this.pages > 5
    },
    before() {
      return this.page
    },
    after() {
      return Math.max(this.pages - (this.page + 1), 0)
    },
  },
}
</script>
